import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tenant, TenantsService } from 'src/app/services/tenants.service';

@Component({
  selector: 'app-tenant-admin-edit',
  templateUrl: './tenant-admin-edit.component.html',
  styleUrl: './tenant-admin-edit.component.scss',
})
export class TenantAdminEditComponent {
  tenant?: Tenant;
  tenantFetchError?: string;
  fetchingTenant = true;

  avataxCustomerCode?: string;
  notes?: string;
  autopayEnabled?: boolean;
  ignoreApiInvoices?: boolean;

  updating = false;
  updateSuccess = false;
  updateError = '';

  qboError = '';

  constructor(
    private tenantsService: TenantsService,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.fetchingTenant = true;
    const tenantId = this.route.snapshot.paramMap.get('tenantId');
    if (tenantId === null || tenantId === '') {
      console.error(new Error('tenant id not provided in route params'));
      this.tenantFetchError = 'Tenant ID not provided in route params';
      this.fetchingTenant = false;
      return;
    }

    this.tenantsService.getTenantById(tenantId).subscribe({
      next: (res) => {
        this.fetchingTenant = false;
        console.log('res: ', res);
        if (res.tenant) {
          this.tenant = res.tenant;
          this.avataxCustomerCode = res.tenant.avatax_customer_code;
          this.notes = res.tenant.notes;
          this.autopayEnabled = res.tenant.autopay_enabled;
          this.ignoreApiInvoices = res.tenant.ignore_api_invoices;
        } else {
          console.error(new Error('No tenant returned from server'));
          this.tenantFetchError = 'No tenant returned from server';
        }
      },
      error: (err) => {
        this.fetchingTenant = false;
        console.error(err);
        this.tenantFetchError = err;
      },
    });
  }

  submitAdminSettings() {
    console.log('submitAdminSettings');
    console.log('avalaraCompanyCode: ', this.avataxCustomerCode);

    this.updating = false;
    this.updateError = '';
    this.updateSuccess = false;
    this.qboError = '';

    if (!this.tenant) {
      this.updateError = 'No tenant found';
      return;
    }

    this.updating = true;

    this.tenantsService
      .updateTenantAdminValues(
        this.tenant!.id,
        this.avataxCustomerCode,
        this.notes,
        this.autopayEnabled ?? false,
        this.ignoreApiInvoices ?? false
      )
      .subscribe({
        next: (res) => {
          console.log('res: ', res);
          this.updating = false;
          this.updateSuccess = true;

          if (res.qbo_error) {
            this.qboError =
              `Tenant was successfully changed in portal, but ` +
              `the Quickbooks update failed: ${res.qbo_error}`;
          }

          setTimeout(() => {
            this.updateSuccess = false;
          }, 5000);
        },
        error: (err) => {
          console.error(err);
          this.updating = false;
          if (
            typeof err === 'string' &&
            err.includes('quickbooks customer not found')
          ) {
            this.updateError =
              `Unable to verify QuickBooks customer code ` +
              `"${this.avataxCustomerCode}". Please verify that the customer ` +
              `code is correct.`;
          } else {
            this.updateError = err;
          }
        },
      });
  }

  back() {
    this.location.back();
  }
}
